import { useTranslation } from 'react-i18next'

import { FormikField, getFormikFormFieldErrorProps } from '../../Formik'
import { TextareaOutlineField } from '../../Textarea'

import {
  REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_MAX_LENGTH,
  REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_MIN_ROWS,
  REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_NAME,
} from './RequestProfileHeaderEditTitleField.constants'

function RequestProfileHeaderEditTitleField(props) {
  const { t } = useTranslation()

  return (
    <FormikField
      {...props}
      autoFocus
      clearable
      withoutManualResize
      Component={TextareaOutlineField}
      getErrorProps={getFormikFormFieldErrorProps}
      label={t('Request.TitleLabelKey')}
      maxLength={REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_MAX_LENGTH}
      minRows={REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_MIN_ROWS}
      name={REQUEST_PROFILE_HEADER_EDIT_TITLE_FIELD_NAME}
      placeholder={t('Request.TitlePlaceholderKey')}
    />
  )
}

export default RequestProfileHeaderEditTitleField
